module.exports = "../../../../platform/assets/pageMainIcon/icon-zuzhi-2-blue.svg";